// classes
import { Pagination } from './Pagination.class'

// composable
import useCatchError from '@/common/composable/useCatchError'
import { CatchedErrorStateT, CatchedErrorHandlerT } from '../types/error.types'

type DataStateConfig<T> = {
    is_loading?: boolean
    is_failed?: boolean
    is_completed?: boolean

    list?: T[]
    pagination?: Pagination

    failure?: {
        error_state: CatchedErrorStateT
        catchError: CatchedErrorHandlerT
    }
}

export class DataState<T> {
    is_loading: boolean
    is_failed: boolean
    is_completed: boolean

    list: T[]
    pagination: Pagination

    failure: {
        error_state: CatchedErrorStateT
        catchError: CatchedErrorHandlerT
    }

    constructor({
        is_loading,
        is_failed,
        is_completed,
        list,
        pagination,
        failure,
    }: DataStateConfig<T>) {
        this.is_loading = is_loading || false
        this.is_failed = is_failed || false
        this.is_completed = is_completed || false

        this.list = list || []
        this.pagination = pagination || new Pagination({})

        this.failure = failure || useCatchError()
    }
}
